import { render, staticRenderFns } from "./StartupGeneralInfo.vue?vue&type=template&id=2b7ba197&scoped=true&"
import script from "./StartupGeneralInfo.vue?vue&type=script&lang=js&"
export * from "./StartupGeneralInfo.vue?vue&type=script&lang=js&"
import style0 from "./StartupGeneralInfo.vue?vue&type=style&index=0&id=2b7ba197&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7ba197",
  null
  
)

export default component.exports